module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-info"
  }, [(_vm.data.length) ? _c('ul', _vm._l((_vm.data), function(item, i) {
    return _c('li', {
      key: i,
      on: {
        "click": function($event) {
          _vm.go(item)
        }
      }
    }, [_c('b', {
      style: ({
        color: _vm.color
      })
    }, [_vm._v("•")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.infoTitle) + " "), (item.infoHlFl * 1 === 1) ? _c('i', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("NEW!")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "time",
      style: ({
        color: _vm.color
      })
    }, [_vm._v(_vm._s(_vm._f("format")(item.infoDt)))])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24060df4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/consultation.vue
// module id = 779
// module chunks = 10